import styled from 'styled-components'
import { grid, layout } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return ![...DIV_SHOULD_FORWARD_PROP, 'pointerCursor'].includes(String(prop))
}

export const Container = styled(Flex).attrs({
  pb: [80, 80, 100, 100, 120],
  pt: [80, 80, 64, 64, 32],
  px: LANDING_INLINE_PADDINGS,
})`
  width: 100%;
  justify-content: center;
`

export const Content = styled.div`
  width: 100%;
`

export const CardsWrapper = styled.div
  .attrs({
    gridTemplateColumns: ['1fr', '1fr', '1fr', 'repeat(2, 1fr)'],
    gridGap: [5, 5, 6],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: grid;
  position: relative;

  ${grid}
`

export const Card = styled(Flex)
  .attrs({
    px: [24, 24, 32],
    borderRadius: [15, 15, 20],
  })
  .withConfig({
    shouldForwardProp,
  })`
  padding-top: 16px;
  padding-bottom: 16px;
  align-items: center;
  border: 1px solid ${themeGet('colors.softPeach')};
  min-height: 155px;
  z-index: 1;
  background-color: ${themeGet('colors.bg.default')};
`

export const LogoHolder = styled.div
  .attrs({
    width: [80, 80, 90],
  })
  .withConfig({
    shouldForwardProp,
  })`
  flex-shrink: 0;
  margin-right: 30px;
  overflow: hidden;

  ${layout}
`

export const TextHolder = styled(Flex)`
  flex-direction: column;
`

export const DotsWrapper = styled(Flex)
  .attrs({
    display: ['none', 'none', 'flex'],
    top: [0, 0, -30, -30, -33],
    right: [0, 0, -30, -30, -33],
  })
  .withConfig({
    shouldForwardProp,
  })`
  position: absolute;
  z-index: 0;
`
